import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

import { isBouyguesOffer } from './isBouyguesOffer'

export function getSelectedMobilePlan(
  items: CartItem[],
): MobilePlanOffer | undefined {
  const itemWithSelectedMobilePlan = items.find((item) => {
    if (!item.mobilePlan) return false

    return isBouyguesOffer(item.mobilePlan.selectedOffer)
  })

  return itemWithSelectedMobilePlan?.mobilePlan?.selectedOffer
}
